import { useEffect } from "react";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useDeleteEducationMutation } from "../../features/education/educationApi";
import swalWithBootstrapButtons from "../../hooks/swalWithBootstrapButtons";

export default function EducationTableRow({ education = {} }) {
  const { id, title, institute, startYear, endYear } = education || {};
  const [
    deleteEducation,
    { isSuccess: deletedIsSuccess, isError: deletedIsError },
  ] = useDeleteEducationMutation();

  useEffect(() => {
    if (!deletedIsError && deletedIsSuccess) {
      swalWithBootstrapButtons.fire(
        "Deleted!",
        "Education Delete Successfully.",
        "success"
      );
    } else if (deletedIsError) {
      swalWithBootstrapButtons.fire(
        "Error",
        "Education Delete Error! :)",
        "error"
      );
    }
  }, [deletedIsError, deletedIsSuccess]);

  const handleDelete = () => {
    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          deleteEducation(id);
        }
      });
  };

  return (
    <tr className="text-center">
      <td>{id}</td>
      <td>{title}</td>
      <td>{institute}</td>
      <td>
        {startYear}-{endYear}
      </td>
      <td>
        <Link
          className="mx-2 btn btn-outline-success"
          to={`/user/education/edit/${id}`}
        >
          Edit
        </Link>
        <button className="mx-2 btn btn-outline-danger" onClick={handleDelete}>
          Delete
        </button>
      </td>
    </tr>
  );
}
